import { useEffect } from 'react';
import { useRuntimeConfig } from '@/hooks/useRuntimeConfig';
import { applyRuntimeTheme } from '@/utils/apply-runtime-theme';

/**
 * Keeps the `:root` theme CSS variables in sync with the runtime config.
 * Call once near the app root.
 */
export const useApplyRuntimeTheme = () => {
  const config = useRuntimeConfig();

  useEffect(() => {
    applyRuntimeTheme(config?.style?.theme);
  }, [config?.style?.theme]);
};
